export const portraits = Array.from(
  { length: 8 },
  (_, index) => `/headshots/paige_${index + 1}.jpg`
);

const storageKey = 'paige-faure-last-hero-portrait';

export function portraitForThisLoad() {
  try {
    const stored = window.localStorage.getItem(storageKey);
    const previous = Number(stored);
    // Keep the existing hero portrait for a first visit, then advance on reload.
    const index = stored === null
      ? 1
      : (Number.isInteger(previous) && previous >= 0 && previous < portraits.length
        ? (previous + 1) % portraits.length
        : 1);
    window.localStorage.setItem(storageKey, String(index));
    return portraits[index];
  } catch (error) {
    return portraits[1];
  }
}
